import { useState } from "react";
import { useUserRole } from "../utils/hooks/useUserRole";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import ReportListTable from "../components/Report/ReportList/Table";
import ModalCreateReport from "../components/Report/ReportList/ModalCreate";

export default function ReportPage() {
  const { isHeadOfficeAccounting } = useUserRole();
  const [openModalCreate, setOpenModalCreate] = useState<boolean>(false);
  const [triggerFetch, setTriggerFetch] = useState<number>(0);

  return (
    <Box sx={{ padding: "8px 0" }}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Typography variant="h6">รายงานการขาย (Sale Daily Report)</Typography>
        {!isHeadOfficeAccounting && (
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() => setOpenModalCreate(true)}
          >
            สร้างรายงานการขายใหม่
          </Button>
        )}
      </Box>
      <ReportListTable triggerFetch={triggerFetch} showNoRunDays />
      {!isHeadOfficeAccounting && (
        <ModalCreateReport
          open={openModalCreate}
          setOpen={setOpenModalCreate}
          setTriggerFetch={setTriggerFetch}
        />
      )}
    </Box>
  );
}
